export enum ViewMode {
  Table = 'table',
  Chart = 'chart',
  Summary = 'summary',
  Pie = 'pie',
  Bar = 'bar',
  Historical = 'historical',
}
